import axios, { AxiosRequestConfig } from "axios";
import store from "@/store/store";
import router from "@/router";
// Make sure that validateStatus allows for all response status numbers
axios.interceptors.request.use((request) => {
  request.validateStatus = function () {
    return true;
  };
  return request;
});

export const post = async function (
  url: string,
  data: any,
  config: AxiosRequestConfig | undefined
) {
  const response = await axios.post(url, data, config);
  if (response.status === 401) {
    // TODO: Redirect the user to the login page
    await router.push("/login");
  }
  return response;
};

export const c_post = async function (url: string, data: any) {
  const response = await axios.post(url, data);
  if (response.status === 401) {
    // TODO: Redirect the user to the login page
    await router.push("/login");
  }
  return response;
};

export const get = async function (
  url: string,
  config: AxiosRequestConfig | undefined
) {
  const response = await axios.get(url, config);
  if (response.status === 401) {
    // TODO: Redirect the user to the login page
    await router.push("/login");
  }
  return response;
};

export const put = async function (
  url: string,
  data: any,
  config: AxiosRequestConfig | undefined
) {
  const response = await axios.put(url, data, config);
  if (response.status === 401) {
    // TODO: Redirect the user to the login page
    await router.push("/login");
  }
  return response;
};

export const del = async function (
  url: string,
  config: AxiosRequestConfig | undefined
) {
  const response = await axios.delete(url, config);
  if (response.status === 401) {
    // TODO: Redirect the user to the login page
    await router.push("/login");
  }

  return response;
};
